export default __webpack_public_path__ + "static/media/Group9183.f2547636.svg";